import {EXTERNAL_FILE_TYPE, MolstarFileViewer} from 'constants/PreviewTypeConstants';

// Keep extensions in sync with MOLECULAR_EXTENSION_TO_FILE_TYPE in
// benchling/external_files/previews.py.
const STRUCTURE_EXTENSION_TO_PREVIEW_TYPE: Record<string, MolstarFileViewer> = {
  pdb: EXTERNAL_FILE_TYPE.MOLSTAR_PDB_VIEWER,
  pdbqt: EXTERNAL_FILE_TYPE.MOLSTAR_PDBQT_VIEWER,
  cif: EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER,
  mmcif: EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER,
  pdbx: EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER,
};

const MOLSTAR_PREVIEW_TYPES: ReadonlySet<string> = new Set<MolstarFileViewer>([
  EXTERNAL_FILE_TYPE.MOLSTAR_PDB_VIEWER,
  EXTERNAL_FILE_TYPE.MOLSTAR_PDBQT_VIEWER,
  EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER,
]);

/**
 * Returns the Mol* preview type for a structure file based on its extension,
 * or null if the file is not a previewable molecular structure.
 */
export function getMolstarPreviewTypeForFilename(name: string): MolstarFileViewer | null {
  const ext = name.split('.').pop()?.toLowerCase() ?? '';
  return STRUCTURE_EXTENSION_TO_PREVIEW_TYPE[ext] ?? null;
}

/**
 * Returns true if the given previewType is one of the Mol* viewer types.
 */
export function isMolstarPreviewType(
  previewType: string | null | undefined
): previewType is MolstarFileViewer {
  return previewType != null && MOLSTAR_PREVIEW_TYPES.has(previewType);
}
